/* fiveaven : connexion / inscription en panneau (maquette Figma « Connexion - Inscription »).
   - l'icone compte (client non connecte) ouvre ce panneau au lieu de la fenetre Shopify ;
   - Connexion : e-mail -> Shopify envoie le code a 6 chiffres (login_hint, page de code Shopify), retour sur la page ;
   - Inscription : prenom, nom, date de naissance, telephone, preferences -> meme connexion par code, puis le profil
     est enregistre dans la fiche client par la page « Bienvenue » de l'application (voir snippet fv-compte). */
(function () {
  "use strict";
  var dlg = document.getElementById("fvc");
  if (!dlg || typeof dlg.showModal !== "function") return;

  var DONNEES = (function () { // donnees Shopify du composant de compte (reseaux actives, consentement marketing)
    try { return JSON.parse((document.getElementById("shopify-customer-account-data") || {}).textContent || "{}"); } catch (e) { return {}; }
  })();
  var BOUTIQUE = DONNEES.shop || {};
  var RESEAUX = { // logos officiels
    google: ["Google", '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="#4285F4" d="M23.5 12.27c0-.82-.07-1.6-.2-2.36H12v4.47h6.46a5.52 5.52 0 0 1-2.4 3.62v3h3.88c2.27-2.09 3.56-5.17 3.56-8.73z"/><path fill="#34A853" d="M12 24c3.24 0 5.96-1.07 7.94-2.9l-3.88-3.01c-1.07.72-2.45 1.15-4.06 1.15-3.12 0-5.77-2.11-6.71-4.95H1.28v3.1A12 12 0 0 0 12 24z"/><path fill="#FBBC05" d="M5.29 14.29A7.2 7.2 0 0 1 4.91 12c0-.8.14-1.57.38-2.29v-3.1H1.28A12 12 0 0 0 0 12c0 1.94.46 3.77 1.28 5.39l4.01-3.1z"/><path fill="#EA4335" d="M12 4.77c1.76 0 3.34.61 4.59 1.8l3.44-3.44C17.95 1.19 15.24 0 12 0A12 12 0 0 0 1.28 6.61l4.01 3.1C6.23 6.88 8.88 4.77 12 4.77z"/></svg>'],
    facebook: ["Facebook", '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="#1877F2" d="M24 12.07C24 5.44 18.63.07 12 .07S0 5.44 0 12.07c0 5.99 4.39 10.95 10.13 11.85v-8.38H7.08v-3.47h3.05V9.43c0-3.01 1.79-4.67 4.53-4.67 1.31 0 2.69.23 2.69.23v2.95h-1.52c-1.49 0-1.95.93-1.95 1.87v2.26h3.33l-.53 3.47h-2.8v8.38C19.61 23.02 24 18.06 24 12.07z"/></svg>'],
    apple: ["Apple", '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="#000" d="M16.37 12.74c-.03-2.68 2.19-3.97 2.29-4.03-1.25-1.82-3.19-2.07-3.88-2.1-1.65-.17-3.22.97-4.06.97-.84 0-2.13-.95-3.5-.92-1.8.03-3.46 1.05-4.39 2.66-1.87 3.25-.48 8.06 1.35 10.7.89 1.29 1.96 2.74 3.36 2.69 1.35-.05 1.86-.87 3.49-.87s2.09.87 3.51.84c1.45-.02 2.37-1.31 3.26-2.61 1.03-1.5 1.45-2.95 1.47-3.02-.03-.01-2.82-1.08-2.85-4.3zM13.7 4.86c.74-.9 1.24-2.15 1.11-3.39-1.07.04-2.36.71-3.13 1.61-.69.79-1.29 2.06-1.13 3.28 1.19.09 2.41-.61 3.15-1.5z"/></svg>']
  };

  var passe = false;
  var EDITEUR = !!(window.Shopify && window.Shopify.designMode); // editeur de theme : la connexion Shopify ne peut pas s'y ouvrir
  var MSG_EDITEUR = "Aperçu de l’éditeur Shopify : la connexion est désactivée ici. Sur le site (menu ⋯ puis Aperçu), ce bouton t’envoie ton code par e-mail.";
  function vue(nom) {
    dlg.querySelectorAll("[data-vue]").forEach(function (v) { v.hidden = v.getAttribute("data-vue") !== nom; });
    dlg.scrollTop = 0;
    var cible = nom === "accueil" ? dlg.querySelector('[data-fvc="inscription"]') : dlg.querySelector('[data-vue="' + nom + '"] input');
    if (cible) setTimeout(function () { try { cible.focus({ preventScroll: true }); } catch (e) { /* rien */ } }, 60);
  }
  function mobile() { return window.matchMedia("(max-width: 750px)").matches; }
  function ouvrir(nom) {
    vue(nom || "accueil");
    if (dlg.open) return;
    if (mobile()) { // maquette mobile : sous l'en-tete, en-tete visible
      var h = document.querySelector("#sticky-header-content, header.header, header");
      var bas = h ? Math.max(0, Math.round(h.getBoundingClientRect().bottom)) : 0;
      dlg.style.setProperty("--fvc-top", bas + "px");
      // fiveaven : fenetre modale aussi sur mobile (focus garde dans le panneau, page inerte pour les lecteurs d'ecran) ;
      // fond transparent sur mobile (fv-compte.css) : l'en-tete reste visible, un toucher dessus referme le panneau
      dlg.showModal();
    } else {
      dlg.style.setProperty("--fvc-top", "0px");
      dlg.showModal();
    }
  }
  function fermer() { if (dlg.open) dlg.close(); }

  function cheminRetour() { // connexion comme inscription aboutissent sur « Mon compte » du site, jamais sur la page compte Shopify
    var u = new URL(window.location.href), th = window.Shopify && window.Shopify.theme;
    var trace = null; try { trace = sessionStorage.getItem("fv-trace"); } catch (x) { trace = null; }
    var garder = u.searchParams.get("view") === "diagnostic" || u.pathname.indexOf("/pages/diagnostic-de-peau") === 0 || !!trace; // le diagnostic garde son retour pour enregistrer le résultat
    var cible = garder ? u : new URL("/pages/about?view=mon-compte", u.origin);
    // rubrique demandée (ex. « Créer ma propre routine » -> #routines) : portée par ?vue=, le fragment ne survit pas à la connexion
    var rubrique = u.searchParams.get("view") === "mon-compte" ? u.hash.replace(/^#/, "") : "";
    if (!garder && /^[a-z0-9-]+$/i.test(rubrique)) cible.searchParams.set("vue", rubrique);
    if (th && th.id && th.role && th.role !== "main" && !cible.searchParams.has("preview_theme_id")) cible.searchParams.set("preview_theme_id", String(th.id));
    return cible.pathname + cible.search;
  }
  function urlConnexion(extra) { // meme adresse que le formulaire Shopify (composant shopify-account)
    var p = new URLSearchParams();
    p.set("return_to", cheminRetour());
    var langue = (document.documentElement.lang || "fr").split("-")[0];
    p.set("locale", langue);
    if (window.Shopify && window.Shopify.country) p.set("region_country", String(window.Shopify.country).toUpperCase());
    Object.keys(extra || {}).forEach(function (k) { if (extra[k] != null) p.set(k, extra[k]); });
    return "/customer_authentication/login?" + p.toString();
  }

  // Reseaux sociaux actives dans Shopify (Parametres > Comptes clients > Authentification) : boutons de la maquette
  (function () {
    var liste = (BOUTIQUE.socialLoginProviders || []).map(function (r) { return r && String(r.handle || "").toLowerCase(); }).filter(function (h) { return RESEAUX[h]; }); // Shopify renvoie « Google », acr_values n'accepte que « provider:google »
    if (!liste.length) return;
    var bloc = dlg.querySelector(".fvc__vue--accueil .fvc__reseaux");
    bloc.querySelector(".fvc__reseaux-liste").innerHTML = liste.map(function (h) {
      return '<a class="fvc__social" href="' + urlConnexion({ acr_values: "provider:" + h }) + '">' + RESEAUX[h][1] + "<span>S’identifier avec " + RESEAUX[h][0] + "</span></a>";
    }).join("");
    bloc.hidden = false;
  })();

  function erreur(form, msg, champ, info) {
    var e = form.querySelector(".fvc__erreur");
    e.classList.toggle("fvc__erreur--info", !!info);
    form.querySelectorAll("[aria-invalid]").forEach(function (i) { i.removeAttribute("aria-invalid"); });
    if (!msg) { e.hidden = true; return false; }
    e.textContent = msg; e.hidden = false;
    if (champ) { champ.setAttribute("aria-invalid", "true"); try { champ.focus(); } catch (x) { /* rien */ } }
    return true;
  }
  var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  function dateIso(v) { // JJ/MM/AAAA (ou AAAA-MM-JJ du remplissage automatique) -> AAAA-MM-JJ, sinon ""
    var m = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(v) || /^(\d{4})-(\d{2})-(\d{2})$/.exec(v);
    if (!m) return "";
    var j = m[1].length === 4 ? +m[3] : +m[1], mo = +m[2], a = m[1].length === 4 ? +m[1] : +m[3];
    var d = new Date(Date.UTC(a, mo - 1, j)), an = new Date().getFullYear();
    if (d.getUTCDate() !== j || d.getUTCMonth() !== mo - 1 || a < an - 110 || d > new Date()) return "";
    return a + "-" + String(mo).padStart(2, "0") + "-" + String(j).padStart(2, "0");
  }
  dlg.addEventListener("input", function (e) { // saisie de la date : les barres se placent toutes seules
    var t = e.target;
    if (!t || t.name !== "naissance") return;
    var iso = /^(\d{4})-(\d{2})-(\d{2})$/.exec(t.value);
    if (iso) { t.value = iso[3] + "/" + iso[2] + "/" + iso[1]; return; }
    var c = t.value.replace(/\D/g, "").slice(0, 8);
    t.value = c.slice(0, 2) + (c.length > 2 ? "/" + c.slice(2, 4) : "") + (c.length > 4 ? "/" + c.slice(4) : "");
  });
  function base64url(txt) {
    var o = new TextEncoder().encode(txt), s = "";
    for (var i = 0; i < o.length; i++) s += String.fromCharCode(o[i]);
    return btoa(s).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
  }
  function envoyer(form, url) {
    if (EDITEUR) { erreur(form, MSG_EDITEUR, null, true); return false; }
    var b = form.querySelector('[type="submit"]');
    if (b) { b.disabled = true; b.textContent = "Envoi du code..."; }
    window.open(url, "_top"); // pleine page, comme le formulaire Shopify (jamais dans un cadre)
    return true;
  }

  dlg.addEventListener("submit", function (e) {
    var form = e.target; e.preventDefault();
    var type = form.getAttribute("data-form");
    var email = form.elements.email, adr = (email.value || "").trim();
    if (type === "connexion") {
      if (!EMAIL.test(adr)) { erreur(form, "Indique une adresse e-mail valide.", email); return; }
      erreur(form, "");
      envoyer(form, urlConnexion({ login_hint: adr, login_hint_mode: "submit" }));
      return;
    }
    // inscription
    var f = form.elements, prenom = f.prenom.value.trim(), nom = f.nom.value.trim(), dn = f.naissance.value, tel = f.tel.value.trim();
    if (!prenom) { erreur(form, "Indique ton prénom.", f.prenom); return; }
    if (!nom) { erreur(form, "Indique ton nom.", f.nom); return; }
    if (dn) {
      dn = dateIso(dn);
      if (!dn) { erreur(form, "Vérifie ta date de naissance (JJ/MM/AAAA).", f.naissance); return; }
    }
    if (!EMAIL.test(adr)) { erreur(form, "Indique une adresse e-mail valide.", email); return; }
    if (tel && !/^[0-9+(). -]{6,25}$/.test(tel)) { erreur(form, "Vérifie ton numéro de téléphone.", f.tel); return; }
    if (!f.rgpd.checked) { erreur(form, "Merci d’accepter la politique des données personnelles pour créer ton compte.", f.rgpd); return; }
    erreur(form, "");
    if (EDITEUR) { erreur(form, MSG_EDITEUR, null, true); return; }
    var pref = f.offres.checked ? "toutes" : (f.importantes.checked ? "importantes" : "aucune");
    var profil = { p: prenom, n: nom, dn: dn || "", t: tel || "", pref: pref, rgpd: new Date().toISOString() };
    var attente = JSON.stringify({ v: base64url(JSON.stringify(profil)), t: Date.now() }); // memorise aussi pour un autre onglet (lien de l'e-mail)
    try { localStorage.setItem("fv-profil", attente); } catch (x) { /* stockage indisponible */ }
    try { sessionStorage.setItem("fv-profil", attente); } catch (x) { /* stockage indisponible */ }
    var extra = { login_hint: adr, login_hint_mode: "submit" };
    if (BOUTIQUE.marketingConsentSigninEnabled) extra.marketing_consent = pref === "aucune" ? "false" : "true";
    envoyer(form, urlConnexion(extra));
  });

  dlg.addEventListener("change", function (e) { // les deux choix d'e-mails s'excluent
    var n = e.target && e.target.name;
    if (n === "offres" && e.target.checked) dlg.querySelector('[name="importantes"]').checked = false;
    if (n === "importantes" && e.target.checked) dlg.querySelector('[name="offres"]').checked = false;
  });

  dlg.addEventListener("click", function (e) {
    var s = e.target.closest ? e.target.closest(".fvc__social") : null;
    if (s) { e.preventDefault(); if (EDITEUR) return; window.open(s.href, "_top"); return; }
    var a = e.target.closest ? e.target.closest("[data-fvc]") : null;
    if (a) {
      var act = a.getAttribute("data-fvc");
      if (act === "fermer") fermer(); else vue(act);
      return;
    }
    var r = dlg.getBoundingClientRect(); // clic sur la page floutee
    if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) fermer();
  });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape" && dlg.open) fermer(); });

  // lien vers le compte ou la connexion Shopify (/account..., /customer_authentication/..., account.fiveaven.com) -> vue du panneau, sinon null
  function vueCompte(href) {
    var u; try { u = new URL(href, window.location.href); } catch (x) { return null; }
    var p = u.pathname.replace(/\/+$/, ""), ici = u.origin === window.location.origin;
    if (/logout/.test(p)) return null;
    if (ici && p === "/account/register") return "inscription";
    if (ici && (p === "/account/login" || p.indexOf("/customer_authentication/") === 0)) return "connexion";
    if ((ici && /^\/account(\/|$)/.test(p)) || u.hostname === "account.fiveaven.com" || (/(^|\.)shopify\.com$/.test(u.hostname) && /^\/\d+\/account/.test(p))) return "accueil";
    return null;
  }

  // icone compte de l'en-tete (composant Shopify) : client non connecte -> ce panneau
  function deconnecte(h) { var b = h && h.shadowRoot && h.shadowRoot.querySelector("button"); return !!(b && b.getAttribute("part") === "signed-out-avatar"); }
  window.addEventListener("click", function (e) {
    if (passe || !e.composedPath) return;
    var chemin = e.composedPath(), h = null;
    for (var i = 0; i < chemin.length; i++) {
      var n = chemin[i];
      if (n === dlg) return;
      if (n.tagName === "SHOPIFY-ACCOUNT") { h = n; break; }
    }
    if (!h) { // liens du theme vers le compte (client non connecte) : meme panneau
      for (var k = 0; k < chemin.length; k++) {
        var a = chemin[k];
        if (a.tagName !== "A" || !a.href) continue;
        var cible = vueCompte(a.href);
        if (cible) { e.preventDefault(); e.stopImmediatePropagation(); ouvrir(cible); }
        return;
      }
      return;
    }
    if (!deconnecte(h)) return;
    e.preventDefault(); e.stopImmediatePropagation();
    if (dlg.open && mobile()) { fermer(); return; } // mobile : pas de croix (maquette), l'icône compte referme le panneau
    ouvrir("accueil");
  }, true);
  (function () { // lien direct : fiveaven.com/#inscription, #connexion ou #compte
    var m = /^#(inscription|connexion|compte)$/.exec(window.location.hash);
    if (!m) return;
    try { history.replaceState(null, "", window.location.pathname + window.location.search); } catch (x) { /* sans effet */ }
    ouvrir(m[1] === "compte" ? "accueil" : m[1]);
  })();

  window.FVCompte = { ouvrir: ouvrir, fermer: fermer };
})();
